import React from "react";

interface SVGRProps {
    title?: string;
    titleId?: string;
}

const Airplane = ({
    title,
    titleId = "tm-icon-arrowDownShape",
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" aria-hidden={!title} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g stroke="#000" strokeLinecap="round" strokeLinejoin="round" clipPath="url(#Airplane)">
            <path d="M4.953 15.765 23.299.617M9.231 17.6l7.489 3.21a1.07 1.07 0 0 0 1.452-.7L23.48 1.18a.535.535 0 0 0-.769-.616L1.063 12.208a1.071 1.071 0 0 0 .086 1.927l3.8 1.63"/>
            <path d="m4.953 15.765 2.6 7.2a.806.806 0 0 0 1.43.168l2.89-4.4"/>
            <path d="M23.299.617 9.23 17.6l-.915 5.9"/>
        </g>
        <defs>
            <clipPath id="Airplane">
            <path fill="#fff" d="M0 0h24v24H0z"/>
            </clipPath>
        </defs>
    </svg>
);

export default Airplane;
